module.exports = new __parcel__URL__("users-and-roles-task-four-illustration.5598079a.svg").toString();